import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router);
var router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_PATH,
    routes: [
        {
            path: '/',
            redirect: '/home',
        },
        {
            path: '/registered',
            component: () => import('@/view/account/Registered.vue'),
        },
        {
            path: '/account',
            component: () => import('@/view/account/Account.vue'),
        },
        {
            path: '/success',
            component: () => import('@/view/account/Success.vue'),
        },
        {
            path: '/login',
            component: () => import('@/view/Login.vue'),
        },
        {
            path: '/country',
            component: () => import('@/view/module/Country.vue'),
        },
        {
            path: '/token',
            component: () => import('@/view/module/Token.vue'),
        },
        {
            path: '/home',
            component: () => import('@/view/InitData.vue'),
            meta: {
                keepAlive: true,
                userAuth: true
            },
            children: [
                {
                    path: '',
                    component: () => import('@/view/Homepage.vue'),
                },
                {
                    path: 'Turn',
                    component: () => import('@/view/module/Turn.vue'),
                },
                {
                    path: 'nesting',
                    component: () => import('@/view/module/Nesting.vue'),
                    meta: {
                        userAuth: true,
                        serverLink:true
                    },
                },
                {
                    path: 'embed',
                    component: () => import('@/view/module/Embed.vue'),
                    meta: {
                        serverLink:true
                    },
                },
                {
                    path: 'quoteChart',
                    component: () => import('@/view/quotation/QuoteChart.vue'),
                },
                {
                    path: 'newsDetail',
                    component: () => import('@/view/news/NewsDetail.vue'),
                },
                {
                    path: 'sucOrdered',
                    component: () => import('@/view/success/SucOrdered.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'trade',
                    component: () => import('@/view/trade/Trade.vue'),
                },
                {
                    path: 'positionChart',
                    component: () => import('@/view/trade/PositionChart.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'pendingChart',
                    component: () => import('@/view/trade/PendingChart.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'positionSuc',
                    component: () => import('@/view/success/PositionSuc.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'modifySuc',
                    component: () => import('@/view/success/ModifySuc.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'attribute',
                    component: () => import('@/view/module/Attribute.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'myself',
                    component: () => import('@/view/myself/Myself.vue'),
                },
                {
                    path: 'newsList',
                    component: () => import('@/view/news/NewsList.vue'),
                },
                {
                    path: 'recharge',
                    component: () => import('@/view/recharge/Recharge.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'rechargeDictConfirm',
                    component: () => import('@/view/recharge/RechargeDictConfirm.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'rechargeResult',
                    component: () => import('@/view/recharge/RechargeResult.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'record',
                    component: () => import('@/view/recharge/Record.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
                {
                    path: 'recordDetail',
                    component: () => import('@/view/recharge/RecordDetail.vue'),
                    meta: {
                        userAuth: true,
                    },
                },
            ]
        },
    ]
});
router.beforeEach((to, from, next) => {
    if (to.query.locale)  store.dispatch("setLocale",to.query.locale);
    if (to.query.token) next({
        path: '/token',
        query: {url: to.path,loginToken:to.query.token}
    });
    //访问主页但未登录
    else if (to.meta.userAuth && !store.state.user.loginname) next({path: '/login'});
    //访问登录页但已登录过
    else if ((to.fullPath.startsWith("/Login") || to.fullPath.startsWith("/login")) && store.state.user.loginname) next({path: '/home'});
    else if (to.fullPath.startsWith("/home") && to.fullPath.indexOf("Turn") < 0 && store.state.quote.tickList.length == 0) next({
        path: '/home/Turn',
        query: {url: to.fullPath}
    });
    next();
});
export default router
